exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget--border-box.social-grid .media-lists li[data-v-358f2015]{flex:0 0 25.000%;-webkit-flex:0 0 25.000%;-ms-flex:0 0 25.000%}.report-news-success img[data-v-358f2015]{display:block;margin-left:auto;margin-right:auto;width:250px;-moz-user-select:none;-webkit-user-select:none;user-select:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-358f2015","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ReportNews.vue
// module id = 192
// module chunks = 0